export const paths = {
  forgotPassword: '/forgot-password',
  signIn: '/sign-in',
};
